import React from 'react'
import { LoginSocialFacebook } from 'reactjs-social-login';
import Facebook from "../../../../../assets/images/icon-facebook.svg";

const FaceBookLogin = ({ setSocialSignInData }) => {
    const appId = process.env.REACT_APP_FACEBOOK_APP_ID;
    return (
        <LoginSocialFacebook
            appId={appId}
            onResolve={({data}) => {
                setSocialSignInData(data);
            }}
            onReject={(error) => {
                console.log("Reject error ==>>", error)
            }}
        >
            <span className="sso-login"><img src={Facebook} alt="" /></span>
        </LoginSocialFacebook>
    )
}

export default FaceBookLogin;